import { NAMESPACE, useLang } from '@/hooks/use-lang';
import React, { useState, forwardRef } from 'react';
import { FileUploader, Alert, GlobalLoading } from '@/shared/components';
import { useMutationQuickOrderUpload } from '@/hooks/quick-order.hook';
import ClickAwayListener from '@mui/base/ClickAwayListener';

interface IProps {
  bulkUpdateFunc: (value) => void;
}
const BulkUpload = forwardRef<HTMLInputElement, IProps>(function BulkUpload(props, ref) {
  const { bulkUpdateFunc } = props;
  const [skuData, setSkuData] = useState([]);
  const { t } = useLang(NAMESPACE.quickOrder);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>('success');
  const [fileName, setFileName] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const uploadFile = useMutationQuickOrderUpload();
  const modalContent = <p>{t('modal.content')}</p>;

  const uploadFunc = async (file: any) => {
    setFileName(file.name);
    GlobalLoading.show();
    uploadFile.mutateAsync(file).then((response: any) => {
      GlobalLoading.hide();
      setShowAlert(true);
      if (response.code === '200') {
        setRefresh(true);
        setAlertType('success');
        setSkuData(response.data.childSkus);
        setTimeout(() => {
          bulkUpdateFunc(response.data.childSkus);
        }, 2e3);
      } else {
        setAlertType('error');
        const errMsg = response?.message || t('error.msg');
        setErrorMsg(errMsg);
      }
    });
  };
  const handleClickAway = () => {
    setShowAlert(false);
  };
  return (
    <div>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div>
          <Alert
            open={showAlert}
            onClose={() => setShowAlert(false)}
            type={alertType || 'success'}
            white
            className="w-full self-start mb-4"
            title={alertType === 'success' ? t('successful') : t('error')}
            content={alertType === 'success' ? fileName + ' ' + t('success') : errorMsg}
          />
        </div>
      </ClickAwayListener>
      <FileUploader
        uploadTxt={t('drag')}
        successTxt={t('complete.msg')}
        outlineBtnTxt={t('remove.file')}
        primaryBtnTxt={t('upload.submit')}
        downloadTxt={t('download.template')}
        downloadFile="/apac/quickorder_template.xlsx"
        supportedFileTypes={'.xls, .xlsx'}
        refresh={refresh}
        resetRefresh={() => setRefresh(false)}
        uploadFunc={(file) => {
          uploadFunc(file);
        }}
        modalTitle={t('modal.title')}
        modalContent={modalContent}
        modalSaveBtnLabel={t('modal.btn.label')}
      />
    </div>
  );
});
export { BulkUpload };
